import { render } from "./CreateForm.vue?vue&type=template&id=0b7fb635&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=0b7fb635&scoped=true&lang=css"
import "./CreateForm.vue?vue&type=style&index=1&id=0b7fb635&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7fb635"]])

export default __exports__